<template>
  <div class="fill-height"
    :style="[
      {'background-color': `#F4F4F4`} 
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-main style="height:100vh;padding-top:87px">
      <div style="max-height:100%; overflow:auto">
        <v-container>
          <v-row class="strategio-titles-windows" >
            <v-col cols="12" class="d-flex">
              <v-icon color="black" style="font-size:52px; margin-right: 5px;"
                @click="goBack"
                >arrow_back</v-icon>
              <span style="font-size:45px;font-weight:bold;color:black;-webkit-text-stroke: 2px black;">
                Carga archivos a carpeta SFTP
              </span>
            </v-col>
          </v-row>

          <!-- <v-row class="ma-5 px-5">
            <validation-config
              v-if="isAdmin"
              :processID="processID"
            ></validation-config>
          </v-row>
          <v-row class="ma-5 px-5">
            <validation-header
              :processID="processID"
            ></validation-header> 
          </v-row>-->
          <v-row class="ma-5 px-5">
            <validation-upload-file
              :processID="processID"
            ></validation-upload-file>
          </v-row>
        </v-container>
      </div>
    </v-main>

    <custom-snack-bar></custom-snack-bar>
    <validation-dialog-error></validation-dialog-error>
    <validation-insert-data-dialog-error></validation-insert-data-dialog-error>
  </div>
</template>

<script>
import StrategioAppBar from '../../components/header-bar/strategio-app-bar.vue'
import ValidationHeader from '../../components/autoservicios/validation/validation-header.vue'
import ValidationUploadFile from '../../components/autoservicios/validation/validation-upload-file.vue'
import ValidationConfig from '../../components/autoservicios/validation/validation-config.vue'
import CustomSnackBar from '../../components/snackbars/custom-snack-bar.vue'
import userStorage from '../../storage/userStorage'
import validationDialogError from '../../components/autoservicios/validation/validation-dialog-error.vue'
import validationInsertDataDialogError from '../../components/autoservicios/validation/validation-insert-data-dialog-error.vue'

export default {
  name: 'autoservicios-process-validation',
  components: {
    StrategioAppBar,
    ValidationHeader,
    ValidationUploadFile,
    ValidationConfig,
    CustomSnackBar,
    validationDialogError,
    validationInsertDataDialogError
  },
  data () {
    const user = userStorage.getUserInfo()
    return {
      processID: Number(this.$route.params.processID),
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN'
    }
  },
  methods: {
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/routes/autoservicios/show-process-validation.vue